import * as Yup from "yup"
import {
  passwordNotLongEnough,
  emailNotLongEnough,
  invalidEmail,
  passwordRequired,
  emailRequired,
  passwordsMustMatch,
  emailTooLong,
  passwordTooLong,
  minCharacters,
  maxCharacters,
  passwordMin,
  passwordRegex,
  passwordWeak,
  confirmPasswordRequired,
} from "../constants/validationMessages"

export const EmailSignupValidation = Yup.object().shape({
  email: Yup.string()
    .min(minCharacters, emailNotLongEnough)
    .max(maxCharacters, emailTooLong)
    .email(invalidEmail)
    .required(emailRequired),
  password: Yup.string()
    .min(passwordMin, passwordNotLongEnough)
    .matches(passwordRegex, passwordWeak)
    .max(maxCharacters, passwordTooLong)
    .required(passwordRequired),
})

export const EmailSigninValidation = Yup.object().shape({
  email: Yup.string()
    .min(minCharacters, emailNotLongEnough)
    .max(maxCharacters, emailTooLong)
    .email(invalidEmail)
    .required(emailRequired),
  password: Yup.string()
    .min(minCharacters, passwordNotLongEnough)
    .required(passwordRequired),
})

export const ForgotPasswordEmailValidation = Yup.object().shape({
  email: Yup.string()
    .min(minCharacters, emailNotLongEnough)
    .max(maxCharacters, emailTooLong)
    .email(invalidEmail)
    .required(emailRequired),
})

export const ConfirmForgotPasswordValidation = Yup.object().shape({
  email: Yup.string()
    .min(minCharacters, emailNotLongEnough)
    .max(maxCharacters, emailTooLong)
    .email(invalidEmail)
    .required(emailRequired),
  password: Yup.string()
    .min(passwordMin, passwordNotLongEnough)
    .matches(passwordRegex, passwordWeak)
    .max(maxCharacters, passwordTooLong)
    .required(passwordRequired),
  confirmPassword: Yup.string()
    .min(passwordMin, passwordNotLongEnough)
    .matches(passwordRegex, passwordWeak)
    .max(maxCharacters, passwordTooLong)
    .oneOf([Yup.ref("password"), null], passwordsMustMatch)
    .required(confirmPasswordRequired),
})
